import { RouteRecordRaw } from 'vue-router';
// import { RouterView } from 'vue-router';

export const palettenkontoRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/PalettenkontoLayout.vue'),
    meta: { scope: 'palettenkonto', title: 'WMS Palettenkonto' },
    children: [{ path: '', name: 'palettenkonto.main', component: () => import('../pages/MainView.vue') }],
  },
];
